<div class="pagination-container">
  <div class="pagination-container-info">
    <div class="pagination-container-info-item">
      Total: {{ pagination.page.totalElements }}
    </div>
    <div class="pagination-container-info-item">
      Pages: {{ pagination.page.totalPages }}
    </div>
    <div class="pagination-container-info-item">
      Size:
      <div *ngFor="let size of sizes"
           class="pagination-container-info-item-circle"
           [class]="{'pagination-container-info-item-circle-active': size == pagination.page.size}"
           (click)="selectSize(size)">
        {{ size }}
      </div>
    </div>
  </div>

  <div *ngIf="pagination.page.totalPages > 1" class="pagination-container-pages">
    <div class="pagination-container-pages-label">
      Pages:
    </div>
    <div class="pagination-nav" *ngIf="!isVerySmallScreen">
      <div (click)="selectPage('1')" class="pagination-container-pages-item pagination-container-pages-item-left">
        <app-icon [icon]="Icons.arrowPageDouble"/>
      </div>
      <div (click)="selectPage((pagination.page.number).toString())" class="pagination-container-pages-item pagination-container-pages-item-left">
        <app-icon [icon]="Icons.arrowPage"/>
      </div>
    </div>
    <div *ngFor="let page of getPaginationArray()"
         class="pagination-container-pages-item"
         [class]="{
           'pagination-container-pages-item-active': Number(page) - 1 == pagination.page.number,
           'pagination-dots': page === '...'
         }"
         (click)="page !== '...' ? selectPage(page.toString()) : null">
      {{ page }}
    </div>
    <div class="pagination-nav" *ngIf="!isVerySmallScreen">
      <div (click)="selectPage((pagination.page.number + 2).toString())" class="pagination-container-pages-item">
        <app-icon [icon]="Icons.arrowPage" [invert]="false"/>
      </div>
      <div (click)="selectPage((pagination.page.totalPages).toString())" class="pagination-container-pages-item">
        <app-icon [icon]="Icons.arrowPageDouble"/>
      </div>
    </div>
    <div class="pagination-mobile-nav" *ngIf="isVerySmallScreen">
      <div (click)="selectPage((pagination.page.number).toString())" class="pagination-container-pages-item pagination-container-pages-item-left">
        <app-icon [icon]="Icons.arrowPage"/>
      </div>
      <div (click)="selectPage((pagination.page.number + 2).toString())" class="pagination-container-pages-item">
        <app-icon [icon]="Icons.arrowPage" [invert]="false"/>
      </div>
    </div>
  </div>
</div>
